import React, {useContext, useEffect} from "react";
import Header from "../../components/UI/Header";
import Footer from "../../components/UI/Footer";
import {useLocation} from "react-router-dom";
import {GlobalContext} from "../../index";

const MainLayout = (props: {children: JSX.Element | JSX.Element[] | null}) => {
  const { pathname } = useLocation();
  const {dispatch} = useContext<any>(GlobalContext);

  useEffect(() => window.scrollTo(0, 0), [pathname]);
  useEffect(() => {
    //Remove loader
    setTimeout(dispatch.bind(null, {isLoading: false}), 0)
  }, [dispatch, pathname])

    return (
        <>
            <Header/>
            {props.children}
            <Footer/>
        </>
    )
}
export default React.memo(MainLayout)
